import { render, staticRenderFns } from "./IpaOverlay.vue?vue&type=template&id=31a4aa0d&scoped=true&"
import script from "./IpaOverlay.vue?vue&type=script&lang=ts&"
export * from "./IpaOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./IpaOverlay.vue?vue&type=style&index=0&id=31a4aa0d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a4aa0d",
  null
  
)

export default component.exports